// extracted by css-extract-rspack-plugin
export default {"rowActions":"Fl2nMcKZQP0Jnpct"};